const jobApplyNowBtns = document.querySelectorAll(
  '[href="/job-application-page/"]'
)
const jobTitleFormInput = document.querySelector(
  '[data-val-required="Please select a job title"]'
)

if (jobApplyNowBtns.length > 0) {
  const jobTitle = window.location.pathname.split('/careers/')[1].split('/')[0]

  jobApplyNowBtns.forEach((btn) => (btn.href += '?jobtitle=' + jobTitle))
}

const addJobTitle = () => {
  // add job title to the job title input field
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has('jobtitle')) {
    jobTitleFormInput.value = searchParams
      .get('jobtitle')
      .replace(/-/g, ' ')
      .split(' ')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ')
  }
}

if (jobTitleFormInput) {
  addJobTitle()
}
